import React from 'react';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import dataGripStore from 'ts/store/DataGrip';
import style from '../../styles/header.module.scss';

function Logo() {
  const { t } = useTranslation();
  const { type, page } = useParams<any>();
  const title = type && page
    ? t(`sidebar.${type}.${page}`)
    : t('sidebar.team.total');

  return (
    <h2 className={style.header_title}>
      {title} - {dataGripStore.projectName}
    </h2>
  );
}

export default Logo;
